import { getMakeAPI, Method } from '@golden/getch';
const makeAPI = getMakeAPI('v1');
export const MEMO_API = {
    GET_MEMO: makeAPI(Method.GET, 'memo')(),
    POST_MEMO: makeAPI(Method.POST, 'memo')()
};
export function createMemoService(api) {
    return {
        getMemo(payload) {
            return api.fetch(MEMO_API.GET_MEMO, { data: payload });
        },
        postMemo(payload) {
            return api.fetch(MEMO_API.POST_MEMO, { data: payload });
        }
    };
}
//# sourceMappingURL=MemoService.js.map